import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  visible: false,
  pageTitle: "",
};

export const appslice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setLoadingAction: (state = initialState, { payload }) => {
      return {
        ...state,
        visible: payload,
      };
    },
    setPageTitleAction: (state, action) => {
      state.pageTitle = action.payload;
    },
  },
});
